import { useCaptureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { PageBody } from "@Light/components/page/PageBody";
import { zip5 } from "@Light/utils/address";
import { Lightning01 } from "@untitledui/icons";
import { EnrollHelpButtonFooter } from "../EnrollHelpButtonFooter";
import { PartnerTosDisclaimer } from "../PartnerTosDisclaimer";
import { useEnrollment } from "../flow/context";
import { EnrollRoute } from "../routes";

export const ZipUtilityIneligible = () => {
  const { requirements, navigate } = useEnrollment();
  const postalCode = requirements.service_address?.value?.postal_code;

  useCaptureEvent({
    event: "enroll_zip_ineligible_viewed",
    condition: true,
    properties: { variant: "screen", postal_code: postalCode ?? null },
  });

  return (
    <BaseZipUtilityIneligible
      postalCode={postalCode}
      onRetry={() => {
        navigate(EnrollRoute.ZipUtilitySearch);
      }}
    />
  );
};

export type BaseZipUtilityIneligibleProps = {
  postalCode?: string;
  onRetry?: () => void;
};

export const BaseZipUtilityIneligible = ({
  postalCode,
  onRetry,
}: BaseZipUtilityIneligibleProps) => (
  <PageBody
    centered
    icon={Lightning01}
    title={
      <span data-testid="zip-utility-ineligible-heading">
        Sorry, but we don&rsquo;t provide service to{" "}
        {postalCode ? zip5(postalCode) : "this area"}
      </span>
    }
    subtitle="This is either in an area where customers can’t choose providers or we haven’t launched there yet."
    footer={
      <div className="flex flex-col gap-3">
        <EnrollHelpButtonFooter helpButtonText="Is this incorrect? Reach out to us">
          <Button
            size="lg"
            className="w-full"
            onClick={onRetry}
            data-testid="zip-utility-ineligible-retry"
          >
            Use a different zip code
          </Button>
        </EnrollHelpButtonFooter>
        <PartnerTosDisclaimer className="text-center" />
      </div>
    }
  />
);
